/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Input_DeviceInputs */

const en_options_adr_input_device = /** @type {(inputs: Options_Adr_Input_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input Device`)
};

const fr_options_adr_input_device = /** @type {(inputs: Options_Adr_Input_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Périphérique d'entrée`)
};

const de_options_adr_input_device = /** @type {(inputs: Options_Adr_Input_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingabegerät`)
};

const it_options_adr_input_device = /** @type {(inputs: Options_Adr_Input_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivo di input`)
};

const ru_options_adr_input_device = /** @type {(inputs: Options_Adr_Input_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Устройство ввода`)
};

const es_options_adr_input_device = /** @type {(inputs: Options_Adr_Input_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivo de entrada`)
};

const zh_cn2_options_adr_input_device = /** @type {(inputs: Options_Adr_Input_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入设备`)
};

const ja_options_adr_input_device = /** @type {(inputs: Options_Adr_Input_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力デバイス`)
};

const hi_options_adr_input_device = /** @type {(inputs: Options_Adr_Input_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इनपुट डिवाइस`)
};

const pt_pt2_options_adr_input_device = /** @type {(inputs: Options_Adr_Input_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivo de entrada`)
};

/**
* | output |
* | --- |
* | "Input Device" |
*
* @param {Options_Adr_Input_DeviceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_input_device = /** @type {((inputs?: Options_Adr_Input_DeviceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Input_DeviceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_adr_input_device(inputs)
	if (locale === "de") return de_options_adr_input_device(inputs)
	if (locale === "it") return it_options_adr_input_device(inputs)
	if (locale === "ru") return ru_options_adr_input_device(inputs)
	if (locale === "es") return es_options_adr_input_device(inputs)
	if (locale === "zh-CN") return zh_cn2_options_adr_input_device(inputs)
	if (locale === "ja") return ja_options_adr_input_device(inputs)
	if (locale === "hi") return hi_options_adr_input_device(inputs)
	if (locale === "pt-PT") return pt_pt2_options_adr_input_device(inputs)
	return en_options_adr_input_device(inputs)
});